import { brandfolderColorPalette } from '@brandfolder/react';
import { Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { PeopleFilterType } from '@components/people_tags/customPeopleTagTypes';

const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${brandfolderColorPalette.neutrals[300]};
  margin-bottom: 24px;
  width: fit-content;
`;

const Tab = styled.button<{ isActive: boolean }>`
  background: none;
  border: none;
  padding: 12px 16px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  cursor: pointer;
  color: ${({ isActive }): string =>
    isActive ? brandfolderColorPalette.primary[600] : brandfolderColorPalette.neutrals[600]};
  border-bottom: 2px solid ${({ isActive }): string =>
    isActive ? brandfolderColorPalette.primary[600] : 'transparent'};
  transition: all 0.2s ease;

  & > span {
    color: ${({ isActive }): string =>
    isActive ? brandfolderColorPalette.primary[600] : brandfolderColorPalette.neutrals[500]};
  }

  &:hover {
    color: ${brandfolderColorPalette.primary[600]};
    background-color: ${brandfolderColorPalette.neutrals[100]};
  }

  &:focus {
    outline: 2px solid ${brandfolderColorPalette.primary[200]};
    outline-offset: 2px;
  }
`;

const Count = styled.span`
  margin-left: 8px;
  font-weight: normal;
`;

interface PeopleManagementFilterProps {
  activeFilter: PeopleFilterType;
  onFilterChange: (filter: PeopleFilterType) => void;
  allCount: number;
  namedCount: number;
  unnamedCount: number;
}

export const PeopleManagementFilter: FunctionComponent<PeopleManagementFilterProps> = ({
  activeFilter,
  onFilterChange,
  allCount,
  namedCount,
  unnamedCount
}) => {
  return (
    <TabsContainer>
      <Tab
        isActive={activeFilter === PeopleFilterType.All}
        onClick={() => onFilterChange(PeopleFilterType.All)}
      >
        <Trans>All</Trans>
        <Count>{allCount}</Count>
      </Tab>
      <Tab
        isActive={activeFilter === PeopleFilterType.Named}
        onClick={() => onFilterChange(PeopleFilterType.Named)}
      >
        <Trans>Named</Trans>
        <Count>{namedCount}</Count>
      </Tab>
      <Tab
        isActive={activeFilter === PeopleFilterType.Unnamed}
        onClick={() => onFilterChange(PeopleFilterType.Unnamed)}
      >
        <Trans>Unnamed</Trans>
        <Count>{unnamedCount}</Count>
      </Tab>
    </TabsContainer>
  );
};
